import { IPaths } from 'Shared/Core/ApiPath/IPaths';

export const SoftwareManagementApiPaths: IPaths = {
  Translation: {
    GetAll: 'ParrotTranslation/GetAll',
    GetAllJson: 'ParrotTranslation/GetAllJson',
  },
};
